module.exports = __webpack_public_path__ + "static/media/motorSanadPlusBlue.3f72cbb8.svg";